(() => {
  document.querySelectorAll('[data-home-catalog]').forEach(menu => {
    if (menu.dataset.catalogReady) return;
    menu.dataset.catalogReady = 'true';
    document.addEventListener('click', event => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !menu.open) return;
      const focusInside = menu.contains(document.activeElement);
      menu.open = false;
      if (focusInside) menu.querySelector('summary').focus();
    });
  });
})();
